export function validEmail(email) {
  if (
    email.search(
      /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
    ) != -1
  ) {
    return true;
  } else {
    return false;
  }
}

export function validStringEmpty(str) {
  return !str || str.trim().length === 0;
}

export function validDateExist(date) {
  if (
    date.search(
      /^([0-9]{4})[./]{1}([0-9]{1,2})[./]{1}([0-9]{1,2})$/
    ) == -1
  ) {
    return false;
  } 
  var temp = date.split("/");
  var year = temp[0]
  var month = temp[1]
  var day = temp[2]

  if (month == 0 || day == 0) {
    return false;
  }
  const limitInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const isLeap = new Date(year, 1, 29).getDate() === 29;
  if (isLeap) {
    limitInMonth[1] = 29;
  }
  return day <= limitInMonth[month - 1];
}

export function validID(str) {
  var letters = new Array(
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "X",
    "Y",
    "W",
    "Z",
    "I",
    "O"
  );
  var multiply = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
  var nums = new Array(2);
  var firstChar;
  var firstNum;
  var lastNum;
  var total = 0;
  var regExpID = /^[a-z](1|2)\d{8}$/i;
  if (str.search(regExpID) == -1) {
    return false;
  } else {
    firstChar = str.charAt(0).toUpperCase();
    lastNum = str.charAt(9);
  }

  for (var i = 0; i < 26; i++) {
    if (firstChar == letters[i]) {
      firstNum = i + 10;
      nums[0] = Math.floor(firstNum / 10);
      nums[1] = firstNum - nums[0] * 10;
      break;
    }
  }

  for (var j = 0; j < multiply.length; j++) {
    if (j < 2) {
      total += nums[j] * multiply[j];
    } else {
      total += parseInt(str.charAt(j - 1)) * multiply[j];
    }
  }

  if (lastNum == 0 && (total % 10) != lastNum ){
    return false;
  }

  if (lastNum != 0 && (10 - (total % 10) != lastNum)) {
    return false;
  }
  return true;
}
